import { atom } from "recoil";

export const notificationsStatsModalStore = atom({
  key: "notificationsStatsModalStore",
  default: {
    show: false,
    loaded: false,
    data: null,
    error: {
      text: "",
      code: 0,
      timestamp: 0,
    },
  },
});